<template>
  <div
    class="cell"
    :class="{
      'clickable': isClickable && isHoverable,
      'black': cellValue === BLACK,
      'white': cellValue === WHITE
    }"
    @click="handleClick"
  >
    <!-- 黑棋 -->
    <div
      v-if="cellValue === BLACK"
      class="piece black"
      :class="{ 'new': isNewMove }"
    >
      <span
        v-if="pieceMeta"
        class="piece-serial"
        :class="{ 'piece-serial--won': pieceMeta.flipped }"
      >{{ pieceMeta.serial }}</span>
    </div>

    <!-- 白棋 -->
    <div
      v-else-if="cellValue === WHITE"
      class="piece white"
      :class="{ 'new': isNewMove }"
    >
      <span
        v-if="pieceMeta"
        class="piece-serial"
        :class="{ 'piece-serial--won': pieceMeta.flipped }"
      >{{ pieceMeta.serial }}</span>
    </div>

    <!-- 可落子提示 -->
    <div
      v-else-if="isValidMove && showMoveGain"
      class="gain-hint"
      :class="{ 'gain-hint--max': isMaxMoveGain }"
    >{{ moveGain }}</div>
    <div
      v-else-if="isValidMove && showHint"
      class="hint"
    ></div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { EMPTY, BLACK, WHITE } from '@/composables'

const props = defineProps({
  cellValue: {
    type: Number,
    default: EMPTY
  },
  index: {
    type: Number,
    required: true
  },
  isValidMove: {
    type: Boolean,
    default: false
  },
  lastMoveIndex: {
    type: Number,
    default: -1
  },
  isClickable: {
    type: Boolean,
    default: true
  },
  showHint: {
    type: Boolean,
    default: true
  },
  pieceMeta: {
    type: Object,
    default: null
  },
  moveGain: {
    type: Number,
    default: 0
  },
  showMoveGain: {
    type: Boolean,
    default: false
  },
  isMaxMoveGain: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['click'])

const isNewMove = computed(() => props.index === props.lastMoveIndex)

const isHoverable = computed(() => props.isValidMove && props.cellValue === EMPTY)

function handleClick() {
  if (props.isClickable && props.isValidMove) {
    emit('click', props.index)
  }
}
</script>

<style scoped>
.cell {
  background: #166534;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.12s;
  position: relative;
}

.cell.clickable:hover {
  background: #14532d;
}

.piece {
  position: relative;
  width: 80%;
  height: 80%;
  border-radius: 50%;
  transition: transform 0.15s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.piece-serial {
  position: relative;
  z-index: 1;
  font-size: clamp(9px, 2.8vw, 13px);
  font-weight: 700;
  line-height: 1;
  user-select: none;
  pointer-events: none;
}

.piece.black .piece-serial {
  color: rgba(248, 250, 252, 0.95);
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.85);
}

.piece.white .piece-serial {
  color: #0f172a;
  text-shadow: 0 1px 0 rgba(255, 255, 255, 0.5);
}

.piece-serial--won {
  text-decoration: underline;
  text-underline-offset: 2px;
  text-decoration-thickness: 1.5px;
}

.piece.black {
  background: radial-gradient(circle at 35% 35%, #334155, #0f172a);
  box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.6);
}

.piece.white {
  background: radial-gradient(circle at 35% 35%, #fff, #e2e8f0);
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.25);
}

.piece.new {
  animation: pop 0.2s ease;
}

@keyframes pop {
  0% {
    transform: scale(0);
  }
  70% {
    transform: scale(1.12);
  }
  100% {
    transform: scale(1);
  }
}

.hint {
  width: 28%;
  height: 28%;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.22);
  pointer-events: none;
}

.gain-hint {
  min-width: 28%;
  min-height: 28%;
  padding: 2px 5px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.3);
  color: #f8fafc;
  font-size: clamp(10px, 2.5vw, 13px);
  font-weight: 700;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.55);
}

.gain-hint--max {
  color: #b91c1c;
  font-weight: 800;
}
</style>